import { IonPage } from '@ionic/react'

import { ThemeSettings } from '@apps-common/apps/my-monitoring/pages/settings/components'
import { NavbarCompany } from '@apps-common/apps/my-monitoring/pages/site/components'
import { PullRefresh } from '@apps-common/components/common/PullRefresh'
import { UserProfileButton } from '@apps-common/components/common/user'
import { LayoutContainerNoSidebar, LayoutPadding } from '@apps-common/components/layout'
import { VertSpacerXl } from '@apps-common/components/layout/spacers'
import { NavbarMyMonitoring } from '@apps-common/components/navigation'
import { ThemeModeToggleWidget } from '@apps-common/components/theme/ThemeModeToggle'

export const SettingsPage = () => {
  const startComponents = <NavbarCompany loading={false} />
  const icons: any = (
    <div className='flex items-start justify-end gap-[20px]'>
      <ThemeModeToggleWidget />
      {/* <SiteSelect callback={(id) => setSiteId(id)} /> */}
      <UserProfileButton />
    </div>
  )

  //   const loading = isLoading || isError

  return (
    <IonPage>
      <NavbarMyMonitoring transparent startComponents={startComponents} icons={icons} />
      <LayoutContainerNoSidebar bgClasses='bg-transparent' overlayClasses=''>
        <PullRefresh loading={false} callback={() => {}} />
        <LayoutPadding
          containerTopPadding='!pt-[0px]'
          topPadding='pt-[0px]'
          classes='flex flex-col items-center justify-center min-h-[50lvh] text-left mx-auto'
          innerClasses='w-full flex flex-col items-center justify-center gap-[30px]'
        >
          <div className='min-w-[min(100%,500px)]'>
            <ThemeSettings />
          </div>
          {/* {!loading && (
            <>
              <SiteDetails data={data} />
              <CardContainer bgClasses='rounded-[50px] bg-secondary/50 backdrop-blur-md !p-4 min-h-[20lvh] min-w-[600px]'>
                <div />
              </CardContainer>
            </>
          )} */}
        </LayoutPadding>
        <VertSpacerXl />
      </LayoutContainerNoSidebar>
    </IonPage>
  )
}
